<span class="created-by">Created with ♥ by <b><a href="https://reidin.com" target="_blank">REIDIN Data Analytics</a></b> 2020</span>
<div class="socials">
  <a href="#" target="_blank" class="ion ion-social-github"></a>
  <a href="#" target="_blank" class="ion ion-social-facebook"></a>
  <a href="#" target="_blank" class="ion ion-social-twitter"></a>
  <a href="#" target="_blank" class="ion ion-social-linkedin"></a>
</div>
